const PREFIX = "Shared/UnitListing/";

export const RECEIVE_UNIT_LISTING = `${PREFIX}RECEIVE_UNIT_LISTING`;
